import * as React from "react";
import {Tab} from 'semantic-ui-react'
import {LisDocViewer} from "./lisDocViewer";
import {EdiDocViewer} from "./edi/EdiDocViewer";
import {MatrixDocViewPage} from "./matrixDocViewer/MatrixDocViewPage";
import {FortrasDocViewer} from "./FortrasDocViewer";
import {CisDocViewer} from "./CisDocViewer";
import {RespondHttpViewer} from "./RespondHttpViewer";
import {LinkingViewer} from "./LinkingViewer";
import {AiRequestsViewer} from "./aiParseResultsHandler/aiRequestsViewer";
import {clampTabIndex} from "../../context/TabSession";

const panes = [
    { menuItem: 'LIS', render: props => <Tab.Pane id='LisTab'><LisDocViewer output={props.externoutput}/></Tab.Pane> },
    { menuItem: 'EDI', render: props => <Tab.Pane id='EdiTab'><EdiDocViewer output={props.externoutput}/></Tab.Pane> },
    { menuItem: 'MATRIX', render: props => <Tab.Pane id='matrixTab'><MatrixDocViewPage output={props.externoutput}/></Tab.Pane> },
    { menuItem: 'FORTRAS', render: props => <Tab.Pane id='fortrasTab'><FortrasDocViewer output={props.externoutput}/></Tab.Pane> },
    { menuItem: 'CIS', render: props => <Tab.Pane id='cisTab'><CisDocViewer output={props.externoutput}/></Tab.Pane> },
    { menuItem: 'RESPOND_HTTP', render: props => <Tab.Pane id='respondHttpTab'><RespondHttpViewer output={props.externoutput}/></Tab.Pane> },
    { menuItem: 'LINKING', render: props => <Tab.Pane id='linkingTab'><LinkingViewer output={props.externoutput}/></Tab.Pane> },
    { menuItem: 'AI REQUESTS', render: () => <Tab.Pane id='aiRequestsTab'><AiRequestsViewer/></Tab.Pane> },
]

const DocViewerTabView = props => <Tab
    id={"DocViewTabView"}
    class={"flexTab"}
    {...props = props}
    panes={panes}
    defaultActiveIndex={clampTabIndex(props.context.tabSession.docViewerTab, panes)}
    onTabChange={(_, data) => {
        props.context.setSingleTabSession("docViewerTab", data.activeIndex)
    }}
/>

export default DocViewerTabView